
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCj9S60m0T0hQ-BrXImBza5Ksm9W7YIrKA',
    libraries: 'places'
  },
  installComponents: true
})

export default {
  name: 'street-view-panorama',
  props: {
    site: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
